import { ChangeBoardPermsView } from 'app/scripts/views/board-menu/ChangeBoardPermsView';

class ChangeBoardAddMemberPermsView extends ChangeBoardPermsView {
  static initClass() {
    this.prototype.viewTitleKey = 'add member permissions';
  }
  getTemplate() {
    return require('app/scripts/views/templates/board_menu_invitations');
  }
  getPerm() {
    return 'invitations';
  }
}
ChangeBoardAddMemberPermsView.initClass();
export { ChangeBoardAddMemberPermsView };
